<section class="slider-Logo" *ngIf="!mobView">
  <div class="container-xl">
    <div class="row">
      <div class="col-md-12">
        <div class="slider-Logo-inner">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <ng-container *ngFor="let item of sociallinks;let i = index">
                <div class="swiper-slide">
                  <!-- <a class="logosName taggetBlankLink" target="_blank" href={{item.social_link}} title={{item.link_title}}>
                        <img alt={{item.link_image}} src={{item.full_image_url}}>
                      </a> -->
                  <div class="swiper-slide"><a class="logosName taggetBlankLink" target="_blank"
                      href={{item.social_link}} title={{item.link_title}}><img alt={{item.link_title}}
                        src="{{sociallinkspath}}{{item.link_image}}"></a></div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="arrow-main">
            <div class="sliderPrev logo-prev" title="Previous"><span class="fa-solid fa-arrow-left"></span></div>
            <div class="sliderNext logo-next" title="Next"><span class="fa-solid fa-arrow-right"></span></div>
            <div class="swiper-button-play" title="play"><a href="#" title="play">play</a></div>
            <div class="swiper-button-pause" title="stop"><a href="#" title="stop">stop</a></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>